import React, { useState } from 'react';
import { Tabs } from '@b-design/fusion';
import $i18n from '@/i18n';
import './index.less';
import Pending from './component/pending';
import Completed from './component/completed';
import MyRequest from './component/myRequest';
import Header from './component/header';
import store from '@/store';
import { getQueryStringArgs } from '@/utils/url-parse';
import CalculateComponent from '@/components/CalculateComponent';

const Approvals: React.FC = () => {
  // 内容区域高度
  const [contentHeight, setContentHeight] = useState(200);
  const [spaceRoleState] = store.useModel('spaceRole');
  const { defaultActiveKey } = getQueryStringArgs();

  return (
    <div className="global-filter-list">
      <Header />
      {spaceRoleState.roleList?.includes('ADMIN') && spaceRoleState.type === 'CONSUMER' ? (
        <div className="detail-container">
          <Tabs shape="wrapped" defaultActiveKey={defaultActiveKey}>
            <Tabs.Item
              title={$i18n.get({ id: 'aopf.pages.approvals.tabPending', dm: '处理中' })}
              key={'Pending'}
            >
              <Pending contentHeight={contentHeight} />
            </Tabs.Item>
            <Tabs.Item
              title={$i18n.get({ id: 'aopf.pages.completed.tabCompleted', dm: '已完成' })}
              key={'Completed'}
            >
              <Completed contentHeight={contentHeight} />
            </Tabs.Item>
            <Tabs.Item
              title={$i18n.get({ id: 'aopf.pages.myRequest.tabMyRequest', dm: '我的请求' })}
              key={'MyRequest'}
            >
               { spaceRoleState?.spaceId && <MyRequest spaceId={spaceRoleState.spaceId} contentHeight={contentHeight} />}
            </Tabs.Item>
          </Tabs>
        </div>
      ) : (
        <div className="detail-container">
          <Tabs shape="wrapped" activeKey={'MyRequest'}>
            <Tabs.Item
              title={$i18n.get({ id: 'aopf.pages.myRequest.tabMyRequest', dm: '我的请求' })}
              key={'MyRequest'}
            >
              { spaceRoleState?.spaceId && <MyRequest spaceId={spaceRoleState.spaceId} contentHeight={contentHeight} />}

            </Tabs.Item>
          </Tabs>
        </div>
      )}
      <CalculateComponent
        otherWidth={280}
        otherHeight={88 + 48 + 56 + 56}
        windowChange={(_width, height) => {
          setContentHeight(height);
        }}
      />
    </div>
  );
};
export default Approvals;
